
import React from 'react';

function Briefcase() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M24.5 9h-12V7h7v1h2V7c0-1.1-.9-2-2-2h-7c-1.1 0-2 .9-2 2v2h-3c-1.65 0-3 1.35-3 3v13c0 1.65 1.35 3 3 3h17c1.65 0 3-1.35 3-3V12c0-1.65-1.35-3-3-3zm-5 2v15h-7V11h7zm-13 14V12c0-.55.45-1 1-1h3v15h-3c-.55 0-1-.45-1-1zm19 0c0 .55-.45 1-1 1h-3V11h3c.55 0 1 .45 1 1v13z'
			></path>
		</svg>
	);
}

export default Briefcase;
